import { render, staticRenderFns } from "./ExampleModal.vue?vue&type=template&id=0aa646bc&scoped=true&"
import script from "./ExampleModal.vue?vue&type=script&lang=js&"
export * from "./ExampleModal.vue?vue&type=script&lang=js&"
import style0 from "./ExampleModal.vue?vue&type=style&index=0&id=0aa646bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa646bc",
  null
  
)

export default component.exports